"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _currency = require("@nerdwallet/currency");
var _templateObject;
var ApyDriver = function ApyDriver(_ref) {
  var driver = _ref.driver,
    renderDivider = _ref.renderDivider;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_currency.Box, {
    paddingY: 2
  }, /*#__PURE__*/_react.default.createElement(_currency.Text, null, driver.label, ": ", driver.value), driver.valueTooltip && /*#__PURE__*/_react.default.createElement(_currency.Tooltip, {
    placement: "bottom",
    content: driver.valueTooltip
  }), driver.description && /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, driver.description))), renderDivider && /*#__PURE__*/_react.default.createElement(_currency.Divider, {
    level: 2
  }));
};
ApyDriver.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment ApyDriver on MarketplaceEntityWithPlacementInterface {\n    placementDrivers {\n      description\n      label\n      value\n      ... on EntityPlacementDriver {\n        valueTooltip\n      }\n    }\n  }\n"])));
var _default = ApyDriver;
exports.default = _default;